export function truncateTo2(num) {
  return Math.trunc(num * 100) / 100;
}